module.exports = require("@jswork/next-slate-defaults");